import {extend} from 'flarum/extend';
import app from 'flarum/app';
import SignUpModal from 'flarum/components/SignUpModal';
import FieldList from './fields/FieldList';
import Uploader from './utils/Uploader';

export default function () {
    extend(SignUpModal.prototype, 'init', function () {
        const forms = app.forum.formulaireSignUpForms() || [];

        this.formulaire = {};

        forms.forEach(form => {
            this.formulaire[form.id()] = {
                value: {},
                uploader: new Uploader(form),
            };
        });
    });

    extend(SignUpModal.prototype, 'fields', function (items) {
        const forms = app.forum.formulaireSignUpForms() || [];

        forms.forEach(form => {
            const state = this.formulaire[form.id()];

            const list = new FieldList({
                configs: form.template(),
                submission: state.value,
                uploader: state.uploader,
                disabled: this.loading || state.uploader.uploading,
            });

            items.add('formulaire-' + form.seoId(), list.listView());
        });
    });

    extend(SignUpModal.prototype, 'submitData', function (data) {
        const forms = app.forum.formulaireSignUpForms() || [];

        forms.forEach(form => {
            // We can't use a relationships object because the /register endpoint doesn't follow JSON:API
            if (!data.formulaireForms) {
                data.formulaireForms = [];
            }

            data.formulaireForms.push({
                id: form.id(),
                attributes: {
                    data: this.formulaire[form.id()].value,
                },
            });
        });
    });
}
